const numericComparer = (a: any, b: any, key: string) => {
  const valueA = a[key];
  const valueB = b[key];

  const numA = Number(valueA) || 0;
  const numB = Number(valueB) || 0;

  return numA - numB;
};

export default numericComparer;
